"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarUserMenu = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/icon/icon");
const icon_names_1 = require("@/components/common/icon/icon-names");
require("@/components/common/list-item/domain/user-item");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
require("@/components/common/menu-item");
require("@/components/overlay/popover/popover");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
/**
 * 사이드바 하단에 고정되는 현재 사용자 영역.
 * 행을 누르면 계정 명령 메뉴가 위로 열린다. 열기·닫기·aria는 mm-popover가 소유한다.
 */
let SidebarUserMenu = class SidebarUserMenu extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.description = '';
        this.avatarSrc = '';
        // popover는 portal로 옮겨져 한 트리에 모이므로, 인스턴스가 여럿이어도 id가 겹치지 않게 한다.
        this.menuId = (0, utils_1.uniqueId)('account-menu');
    }
    render() {
        return (0, lit_1.html) `
      <button type="button" aria-haspopup="menu" aria-controls=${this.menuId}>
        <mm-user-item
          size="medium"
          label=${this.name}
          description=${this.description}
          avatar-src=${this.avatarSrc}
        >
          <mm-icon slot="trailing" name=${icon_names_1.ICON_NAMES.MORE_ACTIONS} size="small"></mm-icon>
        </mm-user-item>
      </button>
      <mm-popover id=${this.menuId} placement="top-start">
        <mm-menu-item-group aria-label="계정" @click=${this.handleMenuClick}>
          <mm-menu-item-action icon=${icon_names_1.ICON_NAMES.PROFILE} label="프로필"></mm-menu-item-action>
          <mm-menu-item-action icon=${icon_names_1.ICON_NAMES.SETTINGS} label="설정"></mm-menu-item-action>
          <mm-menu-item-action icon=${icon_names_1.ICON_NAMES.LOG_OUT} label="로그아웃"></mm-menu-item-action>
        </mm-menu-item-group>
      </mm-popover>
    `;
    }
    // 명령을 고르면 메뉴를 닫는다. popover는 portal로 옮겨져 이 shadow에서 찾을 수 없어 이벤트가 닿은 자리에서 찾는다.
    handleMenuClick(event) {
        ;
        event.currentTarget.closest('mm-popover')?.close();
    }
};
SidebarUserMenu.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      mm-user-item {
        flex: 1;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarUserMenu.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarUserMenu.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
], SidebarUserMenu.prototype, "avatarSrc", void 0);
SidebarUserMenu = __decorate([
    (0, decorators_js_1.customElement)('mm-sidebar-user-menu')
], SidebarUserMenu);
exports.SidebarUserMenu = SidebarUserMenu;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lkZWJhci11c2VyLW1lbnUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzaWRlYmFyLXVzZXItbWVudS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBSTNELHlDQUFzQztBQUN0QyxvRUFBZ0U7QUFDaEUsMERBQXVEO0FBQ3ZELHFGQUFxRjtBQUNyRix5Q0FBc0M7QUFDdEMsZ0RBQTZDO0FBQzdDLCtEQUF5RDtBQUN6RCxtQ0FBa0M7QUFFbEM7OztHQUdHO0FBRUksSUFBTSxlQUFlLEdBQXJCLE1BQU0sZUFBZ0IsU0FBUSxnQkFBVTtJQUF4Qzs7UUFjdUIsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNULGdCQUFXLEdBQUcsRUFBRSxDQUFBO1FBQ1MsY0FBUyxHQUFHLEVBQUUsQ0FBQTtRQUNuRSw4REFBOEQ7UUFDN0MsV0FBTSxHQUFHLElBQUEsZ0JBQVEsRUFBQyxjQUFjLENBQUMsQ0FBQTtJQTRCcEQsQ0FBQztJQTFCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtpRUFDa0QsSUFBSSxDQUFDLE1BQU07OztrQkFHMUQsSUFBSSxDQUFDLElBQUk7d0JBQ0gsSUFBSSxDQUFDLFdBQVc7dUJBQ2pCLElBQUksQ0FBQyxTQUFTOzswQ0FFSyx1QkFBVSxDQUFDLFlBQVk7Ozt1QkFHMUMsSUFBSSxDQUFDLE1BQU07cURBQ21CLElBQUksQ0FBQyxlQUFlO3NDQUNuQyx1QkFBVSxDQUFDLE9BQU87c0NBQ2xCLHVCQUFVLENBQUMsUUFBUTtzQ0FDbkIsdUJBQVUsQ0FBQyxPQUFPOzs7S0FHbkQsQ0FBQTtJQUNILENBQUM7SUFFRCw2RUFBNkU7SUFDckUsZUFBZSxDQUFDLEtBQVk7UUFDbEMsQ0FBQztRQUFDLEtBQUssQ0FBQyxhQUE2QixDQUFDLE9BQU8sQ0FBVSxZQUFZLENBQUMsRUFBRSxLQUFLLEVBQUUsQ0FBQTtJQUMvRSxDQUFDOztBQTVDTSxzQkFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCx1Q0FBb0I7SUFDcEIsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7O0tBUUY7Q0FDRixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs2Q0FBVTtBQUNUO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztvREFBaUI7QUFDUztJQUFwRCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxZQUFZLEVBQUUsQ0FBQztrREFBZTtBQWhCeEQsZUFBZTtJQUQzQixJQUFBLDZCQUFhLEVBQUMsc0JBQXNCLENBQUM7R0FDekIsZUFBZSxDQThDM0I7QUE5Q1ksMENBQWUifQ==